export default "__VITE_ASSET__Bc_caxwx__"